export default {
  name: '王五',
  position: '求职目标： Web前端工程师',
  infos: [
    '1:很多文字',
    '2:很多文字',
    '3:很多文字',
  ],
}
